<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      title="新建"
      width="800px"
      @close="dialogClose">
    <el-form
        ref="form"
        :model="model"
        :rules="ruleValidate"
        class="form"
        label-width="100px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="类型" prop="fieldType">
            <el-select v-model="model.fieldType" placeholder="请选择类型">
              <el-option label="订单表头" :value="10"/>
              <el-option label="订单物料" :value="20"/>
              <el-option label="物料特性" :value="30"/>
              <el-option label="序列类物料特性" :value="40"/>
              <el-option label="组合型序列类特性" :value="50"/>
              <el-option label="物料特性(忽略特殊字符)" :value="60"/>
              <el-option label="物料特性(审批意见)" :value="70"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="SHEET名称" prop="sheetName">
            <el-input v-model.trim="model.sheetName" placeholder="请输入SHEET表名"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="物料名称" prop="materialName">
            <el-input v-model.trim="model.materialName" placeholder="请输入物料名称"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="字段名称" prop="fieldName">
            <el-input v-model.trim="model.fieldName" placeholder="请输入字段名称"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="字段参数" prop="fieldParam">
            <el-input v-model.trim="model.fieldParam" placeholder="请输入字段参数"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="行" prop="excelRow">
            <el-input v-model.trim="model.excelRow" placeholder="请输入行"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="列" prop="excelColumn">
            <el-input v-model.trim="model.excelColumn" placeholder="请输入列"/>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="submitHandle">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    data() {
      return {
        dialogVisible: false,
        index: -1,
        model: {
          fieldType: "",
          sheetName: "",
          materialName: "",
          fieldName: "",
          fieldParam: "",
          excelRow: "",
          excelColumn: "",
        },
        ruleValidate: {
          fieldType: {required: true, message: "请选择类型", trigger: "change"},
          sheetName: {required: true, message: "请输入SHEET名称", trigger: "blur"},
          fieldName: {required: true, message: "请输入字段名称", trigger: "blur"},
          excelRow: {required: true, message: "请输入行", trigger: "blur"},
          excelColumn: {required: true, message: "请输入列", trigger: "blur"},
        },
      };
    },

    methods: {
      open(row, index) {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.form.resetFields();
          if (row) {
            this.model = Object.assign(this.model, row);
            this.index = index;
          }
        });
      },
      dialogClose() {
        this.index = -1;
        this.model.fieldType = "";
        this.model.sheetName = "";
        this.model.materialName = "";
        this.model.fieldParam = "";
        this.model.excelRow = "";
        this.model.excelColumn = "";
      },
      submitHandle() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            let params = {
              index: this.index,
              data: JSON.stringify(this.model),
            };
            this.$emit("save-success", params);
            this.dialogVisible = false;
          }
        });
      },
    },
  };
</script>
